/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from "@angular/router";

import { Observable } from 'rxjs';

import { AuthenticationService } from './authentication.service';
import { BaseService } from "./base-service";

import { BaseInstance } from '../models/base-instance';
import { EntityType } from '../models/entity-type';
import { PropertyType } from '../models/property-type';
import { User } from '../models/user';
import { Url_Base } from 'app/rest-constants';
import { RestService } from './rest-service';

@Injectable()
export class EntityService extends BaseService {
    
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private restService: RestService,
        private http: HttpClient) {
        super(router, authenticationService);
    }
    
    private getUrl(): string {
        return `${Url_Base}/entity/`;
    }
    
    search(type: PropertyType, prefix: string): Observable<BaseInstance[]> {
        const url = `${this.getUrl()}search/${type}/${prefix}`;
        return this.http
            .get<BaseInstance[]>(url, this.restService.createBasicHttpOptions())
            .catch(this.handleObservableError);
    }

    searchByEntity(type: EntityType, prefix: string): Observable<BaseInstance[]> {
        const url = `${this.getUrl()}search/${type}/${prefix}`;
        return this.http
            .get<BaseInstance[]>(url, this.restService.createBasicHttpOptions())
            .catch(this.handleObservableError);
    }
    
    searchUser(prefix: string): Observable<User[]> {
        const url = `${this.getUrl()}search/USER/${prefix}`;        
        return this.http
            .get<User[]>(url, this.restService.createBasicHttpOptions())
            .catch(this.handleObservableError);
    }
    
    private handleObservableError(error: Response | any) {
        console.error(error.message || error);
        return Observable.throw(error.message || error);
    }

}
